// Import the functions you need from the SDKs you need
// import { getAnalytics } from "firebase/analytics"; // I don't need this


import { initializeApp } from "firebase/app"; import { getFirestore } from 'firebase/firestore'

// Your web app's Firebase configuration For Firebase JS SDK v7.20.0 and
// later, measurementId is optional
const firebaseConfig = { apiKey: "AIzaSyBfgOFhpOVdGCW0_ZmrMLnjQwWABGOIBV8",
authDomain: "thrift-savanna.firebaseapp.com", projectId: "thrift-savanna",
storageBucket: "thrift-savanna.appspot.com",
messagingSenderId: "512861203609",
appId: "1:512861203609:web:e181a22a280a2511081c08",
measurementId: "G-36TBTK3XKM" };

// Initialize Firebase
initializeApp(firebaseConfig); 
const db = getFirestore();

export default db;